(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.SetPasswordService = (function(superClass) {
    extend(SetPasswordService, superClass);

    function SetPasswordService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.save = bind(this.save, this);
      this.checkAuthCode = bind(this.checkAuthCode, this);
      this.isCargillUser = bind(this.isCargillUser, this);
      void 0;
    }

    SetPasswordService.prototype.isCargillUser = function(authenticationCode) {
      return this.http.get('backend/session-mgmt/company-internal-name-by-auth-code', {
        params: {
          authenticationCode: authenticationCode
        }
      }).then((function(_this) {
        return function(response) {
          return response.data === 'Cargill';
        };
      })(this));
    };

    SetPasswordService.prototype.checkAuthCode = function(params) {
      return this.http.post('backend/session-mgmt/check-auth-code-to-set-password', {
        auth_code: params.authentication_code,
        is_password_reset: params.is_password_reset,
        client: params.target
      });
    };

    SetPasswordService.prototype.save = function(params) {
      return this.http.post('backend/session-mgmt/update-password', {
        client: params.client,
        policy: params.policy,
        auth_code: params.auth_code,
        auth_verify: params.auth_verify,
        password: params.password,
        password_confirm: params.password_confirm,
        email: params.email,
        data_token: params.data_token
      });
    };

    return SetPasswordService;

  })(Service);

}).call(this);
